export const popularCryptos = state => state.popularCryptos;
export const popularCryptosError = state => state.popularCryptosError;
export const popularCryptosLoading = state => state.popularCryptosLoading;
